module.exports = __webpack_public_path__ + "img/home-normal.f8e06e2d.svg";